import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/darujte-predplatne" as const,
	[Locale.en]: "/gift-subscription" as const,
} satisfies LocalizedString;

export function getGiftSubscriptionPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
